import { initDB, setSetting, getSetting } from '../db/indexeddb.js';
import { encryptText, decryptText } from '../crypto/webcrypto.js';

const TOKEN_KEY = 'oauthTokens';

export async function saveTokens(vaultKey, tokenPayload) {
  const db = await initDB();
  const encrypted = await encryptText(vaultKey, JSON.stringify(tokenPayload));
  await setSetting(db, TOKEN_KEY, encrypted);
}

export async function loadTokens(vaultKey) {
  const db = await initDB();
  const stored = await getSetting(db, TOKEN_KEY);
  if (!stored) return null;
  const plaintext = await decryptText(vaultKey, stored.value ?? stored);
  return JSON.parse(plaintext);
}

export async function clearTokens() {
  const db = await initDB();
  await setSetting(db, TOKEN_KEY, null);
}
